import React from 'react'
import Header from './Header'
import PageTitle from '../Components/PageTitle'
import Footer from './Footer'

const Terms = () => {
  return (
    <>
    <Header />

    <PageTitle 
    title=""
    description=""
    keywords=""
    url="/terms" 
    />


    Terms
    
    <Footer />
    </>
  )
}

export default Terms